import React from 'react';
import AppConfig from 'Config/AppConfig';
import NavigationUtils from '../../../Utils/NavigationUtils';
import c from '../../../Components/AuthLayout/authContent.module.less';

export const Auth2ErrorNoAccess = () => {
  const loginPath = `/${AppConfig.ACCOUNTS_PREFIX}login/`;
  return (
    <>
      <h1 className={c.title}>Seems like you have no permission for this login</h1>
      <p className={c.text}>It looks like your account doesn&#39;t have access to log in via Single Sign-On (SSO).</p>
      <p className={c.text}>Please contact your administrator or the support team to request access.</p>
      <div className={c.actions}>
        <a
          className={c.btnPrimary}
          href={loginPath}
          id="submit-id-login"
          onClick={(e) => NavigationUtils.navigate(e, loginPath)}
        >
          Try a different account
        </a>
      </div>
    </>
  );
};

export default Auth2ErrorNoAccess;
